<template>
    <v-card>
        <v-img
          :src="require(`@/assets/shop/${item.images[0]}`)"
          class="white--text align-end"
          transition="scale-transition"
          :gradient="isSelected ? 'to bottom, rgba(255,255,0,.1), rgba(10,10,0,.5)' : 'to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)'"
          height="200px"
          @click="!(!selectedVariant && item.variants?.length > 0) ? toggleItem() : ''"
        >
          <v-card-title>{{ item.name }}</v-card-title>
          <div v-if="isSelected" class="selected-overlay">
            <v-icon large color="white">mdi-check-circle</v-icon>
            <span>Im Warenkorb</span>
          </div>
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      <v-card-actions>
        <v-select
          v-if="item.variants?.length > 1"
          v-model="selectedVariant"
          class="mr-2"
          :items="item.variants"
          item-text="size"
          item-value="id"
          label="Auswahl"
          :disabled="isSelected"
          dense
          outlined
          hide-details
        >
        </v-select>
        <v-spacer></v-spacer>
        <v-btn
          icon
          :color="isSelected ? 'error' : 'green darken-2'"
          :disabled="!selectedVariant"
          @click="toggleItem"
        >
          <v-icon> {{ isSelected ? 'mdi-cart-remove' : 'mdi-cart-plus' }}</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
export default {
  name: "ShopItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedVariant: null,
      isSelected: false,
    };
  },
  mounted() {
    if (this.item.variants?.length === 1) {
      this.selectedVariant = this.item.variants[0].id;
    }
  },
  computed: {

  },
  methods: {
    toggleItem() {
      if (this.isSelected) {
        this.$emit('remove-item', this.item.id)
      } else {
        this.$emit('add-item', {
          product_id: this.item.id,      // <-- DAS FEHLT!
          variant_id: this.selectedVariant,
          quantity: 1,
          size: this.item.variants?.find(v => v.id === this.selectedVariant)?.size || null
        })
      }
      this.isSelected = !this.isSelected;
    }
  }
};
</script>

<style scoped>
.v-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.variant-select .v-select__selection {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected-overlay {
  position: absolute;
  inset: 0;
  background: rgba(46,125,50,0.75);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
}

</style>
